import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer } from 'utils/redux-injectors';
import { PermissionList } from 'services/openapi';

export interface PermissionState {
  permissions: PermissionList[];
  loading: boolean;
  error: string | null;
}

export const initialState: PermissionState = {
  permissions: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    fetchPermissionsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPermissionsSuccess(state, action: PayloadAction<PermissionList[]>) {
      state.permissions = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchPermissionsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePermissions(state, action: PayloadAction<PermissionList[]>) {
      state.permissions = action.payload;
    },
    clearPermissions(state) {
      state.permissions = [];
    },
  },
});

export const { actions: PermissionActions } = slice;

export const usePermissionSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};
